/**
 * Formata título de alerta: primeira letra maiúscula, demais minúsculas.
 * Opcionalmente acrescenta contagem entre parênteses.
 */
export function formatAlertTitle(title: string, count?: number): string {
  const trimmed = title.trim();
  if (!trimmed) return '';

  const normalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();

  if (count === undefined) {
    return normalized;
  }

  return `${normalized} (${count})`;
}
